module.exports = __webpack_public_path__ + "img/blurbg.c2274c06.jpg";